/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import Link from 'next/link';
import styles from './logo.module.scss';
import SmartImage from '../../smartImage/smartImage';

export default function Logo({
  logo = {
    path: '',
    alt: '',
    link: '/',
  },
  type = null,
}) {
  return (
    <div className={styles.logo}>
      {logo && logo?.path && (
        <Link href={logo.link} className={styles.link}>
          <SmartImage
            className={` ${
              type === 'Patient Solutions' ? styles.pfLogo : styles.image
            }`}
            alt={logo.alt}
            src={logo.path}
            height={logo?.height}
            width={logo?.width}
            priority
          />
        </Link>
      )}
    </div>
  );
}

Logo.propTypes = {
  logo: PropTypes.shape({
    path: PropTypes.string,
    alt: PropTypes.string,
    link: PropTypes.string,
  }),
  type: PropTypes.string,
};
